import { createSlice, PayloadAction } from '@reduxjs/toolkit';



export type StateTooltip ={
    hideTooltip: boolean
}

const initialState:StateTooltip = {
    hideTooltip: true
};

const tooltipSlice = createSlice({
    name: 'tooltip',
    initialState: initialState,
    reducers: {
        setHideTooltip: (state,{payload}: PayloadAction<boolean>) => {
            state.hideTooltip=payload;
        },
    },
  });

export const tooltipReducer = tooltipSlice.reducer;
export const tooltipActions = tooltipSlice.actions;